@if (isLoggedIn && hasPersonalContent && isPersonalContentEnabled) {
<button [id]="id" [routerLink]="['/personal-content']" [title]="username" class="hidden md:inline-flex" mat-button>
  <mat-icon class="fill">person</mat-icon>
  <span class="hidden md:inline">{{ username | truncate : 15 }}</span>
</button>
} @if (isLoggedIn && hasPersonalContent && isPersonalContentEnabled) {
<button [id]="id" [routerLink]="['/personal-content']" [title]="username" class="inline-flex md:hidden" mat-icon-button>
  <mat-icon class="fill">person</mat-icon>
</button>
} @if (isLoggedIn && (!hasPersonalContent || !isPersonalContentEnabled)) {
<button [id]="id" [title]="username" class="hidden md:inline-flex" mat-button>
  <mat-icon class="fill">person</mat-icon>
  <span class="hidden md:inline">{{ username | truncate : 15 }}</span>
</button>
} @if (isLoggedIn && (!hasPersonalContent || !isPersonalContentEnabled)) {
<button [id]="id" [title]="username" class="inline-flex md:hidden" mat-icon-button>
  <mat-icon class="fill">person</mat-icon>
</button>
}
